import React, { Component } from "react";
import { Grid, Row, Col, FormControl, FormGroup, Panel, ControlLabel } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Parse from 'parse';
import logo from './../../assets/img/logo-blanco.svg';
import CancelButton from "../Components/Presentation/CancelButton/CancelButton";
import PrimaryButton from "../Components/Presentation/PrimaryButton/PrimaryButton";

class RegisterPage extends Component {
  constructor(props) {
    super();
    this.state= {
      email:"",
      name:"",
      password:"",
      passwordConfirm:"",
      isError:false,
      error: ""
    }
  }

  handleBtnLogin = () => {
    this.props.history.push('/pages/login-page');
  }

  validateEmail = (email)=>{
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validateData = (email, name, password, passwordConfirm, phone) => {
    if(email === ""){
      return "Necesitamos tu email";
    }

    if(!this.validateEmail(email)){
      return "Tu email no es válido";
    }

    if(name === ""){
      return "Tu nombre completo es necesario";
    }

    if(phone === ""){
      return "Tu teléfono es necesario";
    }

    if(password === ""){
      return "El password es necesario";
    }

    if(password !== passwordConfirm){
      return "El password no coincide";
    }
    return null;
  }

  handleBtnRegister = async () => {
    const {email,name,password, passwordConfirm, phone } = this.state;

    let error = this.validateData(email, name, password, passwordConfirm, phone);
    if(error !== null){
      this.setState({
        isError: true,
        error: error
      });
      return;
    }

    const user = new Parse.User()
    user.set('username', email);
    user.set('email', email);
    user.set('name', name);
    user.set('password', password);
    user.set('phone', phone);

    user.signUp()
    .then((user) => {
      this.props.history.push('/dashboard');
    }).catch((error) => {
      let errorParser = new Parse.Error(error);
      if(error.message === "Account already exists for this username."){
        this.setState({
          isError: true,
          error: `${email} ya esta registrado, inicia sesión o recupera tu contraseña.`
        });
      }
      console.log(error);
    });
      
  }

  render() {
    const {isError, error} = this.state;


    return (
      <Grid>
        <Row>
          <div className="vertical-separator-64px"></div>
          <Col md={4} sm={4}>
              <img src={logo} className="image-fluid logo-login"/>
          </Col>
        </Row>
        <div className="vertical-separator-64px"></div>
       
        <Row>
          <Col md={4} mdOffset={0} sm={8} smOffset={2}>
            <Card 
              hidden={this.state.cardHidden}
              textCenter
              title="Activa tu cuenta para empezar a registrar pacientes."
              content={
                <div>
                <Row>
                  <div className="vertical-separator-16px"></div>
                  <Col md={12}>
                    <form>
                      <FormGroup>
                        <ControlLabel>Correo electrónico</ControlLabel>
                        <FormControl 
                          type="email" 
                          placeholder="El que registraste en la certificaicón" 
                          onChange={ (evt) => {this.setState({email: evt.target.value})}}
                          />
                      </FormGroup>
                      <FormGroup>
                        <ControlLabel>Nombre completo</ControlLabel>
                        <FormControl 
                          type="text" 
                          placeholder="Nombre ApellidoPaterno ApellidoMaterno" 
                          onChange={ (evt) => {this.setState({name: evt.target.value})}}
                          />
                      </FormGroup>
                      <FormGroup>
                        <ControlLabel>Teléfono</ControlLabel>
                        <FormControl 
                          type="text" 
                          placeholder="10 dígitos sin guiones" 
                          onChange={ (evt) => {this.setState({phone: evt.target.value})}}
                          />
                      </FormGroup>
                      <FormGroup>
                        <ControlLabel>Crea una contraseña</ControlLabel>
                        <FormControl 
                          type="password" 
                          placeholder="" 
                          onChange={ (evt) => {this.setState({password: evt.target.value})}}                        
                          />
                      </FormGroup>
                      <FormGroup>
                        <ControlLabel>Confirma tu contraseña</ControlLabel>
                        <FormControl
                          type="password"
                          placeholder=""
                          onChange={ (evt) => { this.setState({ passwordConfirm: evt.target.value}) }}
                        />
                      </FormGroup>
                        
                      <div>
                        <Row>
                          <Col md={5} mdOffset={1}>
                            {isError ? 
                              <p className="label label-warning">{error}</p>
                            :
                              null
                            }
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6} mdOffset={0} sm={5} smOffset={1} className="text-center">
                            <CancelButton 
                              onClick={this.handleBtnLogin}
                              text="Ya tengo cuenta"
                            />                              
                          </Col>
                          <Col md={6} sm={5} className="text-center">
                            <PrimaryButton 
                              onClick={this.handleBtnRegister}
                              text="Crear Cuenta"
                            />
                          </Col>
                        </Row>
                        <div className="vertical-separator-24px"></div>
                      </div>
                    </form>
                  </Col>
                </Row>
                </div>
              }
            >
            </Card>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default RegisterPage;



// WEBPACK FOOTER //
// ./src/views/Pages/RegisterPage.jsx